module.exports = __webpack_public_path__ + "static/media/FiraSans-LightItalic.6d15364f.ttf";